const env = import.meta.env

const localDevelopmentDefaults = {
  VITE_API_URL: 'http://localhost:3001',
  VITE_LEGACY_API_URL: 'http://localhost:3001',
  VITE_USER_POOL_ID: 'local-user-pool',
  VITE_CLIENT_ID: 'local-client-id',
  VITE_COGNITO_DOMAIN: 'localhost',
  VITE_REDIRECT_URI: 'http://localhost:5173/callback',
  VITE_LOGOUT_URI: 'http://localhost:5173',
  VITE_APP_URL: 'http://localhost:5173',
}

function publicConfigValue(name) {
  const value = env[name]
  if (value) return value
  if (env.DEV) return localDevelopmentDefaults[name]
  throw new Error(`Missing public frontend configuration: ${name}`)
}

const config = {
  API_URL: publicConfigValue('VITE_API_URL'),
  LEGACY_API_URL: publicConfigValue('VITE_LEGACY_API_URL'),
  USER_POOL_ID: publicConfigValue('VITE_USER_POOL_ID'),
  CLIENT_ID: publicConfigValue('VITE_CLIENT_ID'),
  COGNITO_DOMAIN: publicConfigValue('VITE_COGNITO_DOMAIN'),
  REDIRECT_URI: publicConfigValue('VITE_REDIRECT_URI'),
  LOGOUT_URI: publicConfigValue('VITE_LOGOUT_URI'),
  APP_URL: publicConfigValue('VITE_APP_URL'),

  PLANS: {
    free: {
      name: 'Free',
      price: '€0',
      maxJobs: 1,
      maxCVsPerMonth: 5,
      maxMembers: 1,
      features: [
        '1 active job',
        'Up to 5 CVs',
        'AI-powered ranking',
        'Basic score breakdown',
      ],
    },
    starter: {
      name: 'Starter',
      price: '€39',
      maxJobs: 5,
      maxCVsPerMonth: 400,
      maxMembers: 1,
      features: [
        'Up to 5 active jobs',
        'Up to 400 CVs per month',
        'Includes all Free features',
        'Skills & evidence extraction',
        'Export results',
      ],
    },
    pro: {
      name: 'Pro',
      price: '€69',
      maxJobs: 20,
      maxCVsPerMonth: 2000,
      maxMembers: 1,
      features: [
        'Up to 20 active jobs',
        'Up to 2,000 CVs per month',
        'Includes all Starter features',
        'Candidate comparison',
      ],
    },
    business: {
      name: 'Business',
      price: '€129',
      maxJobs: 100,
      maxCVsPerMonth: 10000,
      maxMembers: 5,
      features: [
        'Up to 100 active jobs',
        'Up to 10,000 CVs per month',
        'Includes all Pro features',
      ],
    },
    enterprise: {
      name: 'Enterprise',
      price: 'Custom',
      maxJobs: -1,
      maxCVsPerMonth: -1,
      maxMembers: -1,
      features: [
        'Custom usage limits',
        'Custom commercial terms',
        'Let us discuss your requirements',
      ],
    },
  },
}

export default config
